export const MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY = 'single_voyage_point_sortable_key'